export default "__VITE_ASSET__Bed4G2Du__"